const VUE_APP_MODE = process.env.NODE_ENV;
let baseURL;
console.log(VUE_APP_MODE)
if (VUE_APP_MODE == 'dev') { // 本地

    // baseURL = 'http://192.168.2.210:8088';//本地
    baseURL = 'http://api.run.tuanhaocai.com';
} else {
    switch (VUE_APP_MODE) {
        case 'production':// 生产
            baseURL = 'http://api.run.tuanhaocai.com';
            break;
        case 'development':// 开发环境
            baseURL = 'http://develop.api.center.tuanhaocai.com';
            break;
        case 'test':// 测试环境
            baseURL = 'http://develop.api.center.tuanhaocai.com';
            break;
        default:// 测试
            baseURL = 'http://develop.api.center.tuanhaocai.com';
            break;
    }
}
module.exports = {
    baseURL
};